// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1FkHT","col":"Table_col__TsffO","fulfillmentStatus":"Table_fulfillmentStatus__1e9wf","emailCol":"Table_emailCol__35ask"};